module.exports = __webpack_public_path__ + "img/weddings_13_V.1def27f2.webp";